export enum CheckoutLifecycleEventPostMessageName {
    backToTicketSelection = 'backToTicketSelection',
    checkoutFormLoaded = 'checkoutFormLoaded',
    deliveryMethodFormLoaded = 'deliveryMethodFormLoaded',
    orderComplete = 'orderComplete',
    orderStart = 'orderStart',
    organizerQuestionsFormLoaded = 'organizerQuestionsFormLoaded',
    organizerQuestionsFormResize = 'organizerQuestionsFormResize',
    protectCheckout = 'protectCheckout',
    ticketQuantityChange = 'ticketQuantityChange',
    ticketSelectionSubmit = 'ticketSelectionSubmit',
    ticketSelectionCompactLoaded = 'ticketSelectionCompactLoaded',
    ticketSelectionResize = 'ticketSelectionResize',
    widgetModalClose = 'widgetModalClose',
}
